const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
const COARSE_POINTER_QUERY = "(pointer: coarse)";

class LyleRichText extends HTMLElement {
  #motionQuery = null;
  #coarsePointerQuery = null;

  connectedCallback() {
    this.#motionQuery = window.matchMedia(REDUCED_MOTION_QUERY);
    this.#motionQuery.addEventListener(
      "change",
      this.#handleMotionPreferenceChange,
    );
    this.#coarsePointerQuery = window.matchMedia(COARSE_POINTER_QUERY);
    this.#initAnimation();
  }

  disconnectedCallback() {
    this.removeEventListener("pointerenter", this.#handlePointerEnter);
    this.#motionQuery?.removeEventListener(
      "change",
      this.#handleMotionPreferenceChange,
    );
    this.#motionQuery = null;
    this.#coarsePointerQuery = null;
  }

  #handleMotionPreferenceChange = () => {
    if (this.#motionQuery?.matches) {
      this.classList.add("is-active");
      this.removeEventListener("pointerenter", this.#handlePointerEnter);
    }
  };

  #handlePointerEnter = () => {
    this.classList.add("is-active");
    this.removeEventListener("pointerenter", this.#handlePointerEnter);
  };

  #initAnimation() {
    if (
      this.#motionQuery?.matches ||
      this.#coarsePointerQuery?.matches ||
      !window.matchMedia("(hover: hover)").matches
    ) {
      this.classList.add("is-active");
      return;
    }

    this.classList.add("is-observed");
    this.addEventListener("pointerenter", this.#handlePointerEnter);
  }
}

if (!customElements.get("lyle-rich-text")) {
  customElements.define("lyle-rich-text", LyleRichText);
}
